import errorPage from './pages/errorPage'
import user from './pages/user'

const pageRouters = [
  ...errorPage,
  ...user
]

export default pageRouters
